import React from 'react';
import Header from './Header';
import FooterOther from './FooterOther';
import tomografia from '../assets/images/IMG_3958.png';

const tomography = () => {
    return (
        <div>
            <Header />
            <img src={tomografia} className="image-ajustada" style={{ width: '100%' }} alt="Tomografia" />
            <section className="request-proposal" id="solicitar-proposta">
                <div className="container-fluid">
                    <div className="row p-0 text-center">
                        <div className="col-12 title">Unidade de Tomografia</div>
                    </div>
                </div>
            </section>
            <section className="request-proposal-form" id="solicitar-proposta">
                <div className="container py-3">
                    <div className="row">
                        <div className="col-12">
                            A unidade móvel de tomografia é uma solução prática e inovadora para oferecer exames de imagem de alta precisão diretamente no local da sua empresa, evento ou instituição de saúde. Totalmente equipada com tecnologia de ponta, está pronta para uso imediato, garantindo agilidade e qualidade no diagnóstico.
                        </div>
                        <div className="col-12 py-3">
                            Essa solução elimina a necessidade de deslocamentos a clínicas ou hospitais, proporcionando conforto e eficiência. Flexíveis e adaptáveis, as unidades atendem diferentes demandas, desde ações preventivas até suporte a diagnósticos mais complexos, otimizando o tempo e os recursos dos pacientes e empresas.
                        </div>
                        <div className="col-12 py-3">
                            <strong>Exames e Serviços Disponíveis: </strong>
                        </div>
                        <div className="col-12 py-3">
                            <ul>
                                <li>Carreta de Saúde com um TC de 16 canais </li>
                                <li>Realização de exames de tomografia </li>
                                <li>Equipe Capacitada </li>
                                <li>Insumos Inclusos </li>
                                <li>Também realizamos apenas locação da Unidade Móvel </li>
                            </ul>
                        </div>
                        <div className="col-12 py-3">
                            Ideal para atender empresas, eventos e instituições de saúde, nossa unidade móvel de tomografia leva tecnologia avançada onde ela for necessária, com a garantia de um diagnóstico eficiente e acessível.
                        </div>
                        <div className="col-3 py-2"> <a href="https://wa.me/556598106742" target="_blank" className="btn btn-warning text-uppercase d-block rounded-0 py-3"><strong>Quero Contratar</strong></a> </div>

                    </div>
                </div>
            </section>
            <FooterOther />
        </div>

    );
};

export default tomography;